import { ModalMessage } from "../../../../components/ModalMessage";
import useStoreGridCollaborator from "./store/useStore";
import { GridCollaboratorProvider } from "./store";
import TitleGridCollaborator from "./components/TitleGridCollaborator";
import FilterGridCollaborator from "./components/FilterGridCollaborator";
import TableGridCollaborator from "./components/TableGridCollaborator";
import "./index.scss";

import { ModalPopUp } from "../../../../components/ModalPopUp";
import { ContentModal } from "../../../History/components/ContentModal";


function GridCollaborator(props: any) {
  const {
    needModalDelete,
    needModalPassword,
    needModalPopUp,
    setNeedModalDelete,
    setNeedModalPopUp,
    handleDeleteClick,
    setNeedModalPassword,
    handlePasswordClick,
  } = useStoreGridCollaborator();

  return (
    <>
      <ModalMessage
        status={needModalDelete.status}
        id={needModalDelete.id}
        onClickCancel={setNeedModalDelete}
        onClickConfirm={handleDeleteClick}
        text="Confirma a exclusão?"
      />
      <ModalMessage
        status={needModalPassword.status}
        email={needModalPassword.email}
        onClickCancel={setNeedModalPassword}
        onClickConfirm={handlePasswordClick}
        text="Confirma o envio do e-mail?"
      />
       <ModalPopUp 
        className="controller-modal" 
        status={needModalPopUp.status}
        onClickCancel={setNeedModalPopUp}>
          <ContentModal listRender={needModalPopUp.listRender} needModal={needModalPopUp.id} needSpinner={false}/>
      </ModalPopUp>
      <div className="collaboratorContainer box-header collaboratorContainerListCenter">
        <TitleGridCollaborator />
        <FilterGridCollaborator />
        <TableGridCollaborator />
      </div>
    </>
  );
}

export default function ListCollaborator() {
  return (
    <GridCollaboratorProvider>
      <GridCollaborator />
    </GridCollaboratorProvider>
  );
}
